import React, { useEffect, useState } from "react";
import axios from 'axios';
import { API_BASE_URL } from "../../Variables";
import "./ReviewsView.css";
import StarRating from '../StarRating'; 

function ReviewsView ({ userId, bookId }){
  const [reviews, setReviews] = useState([]);
  const token = localStorage.getItem('token');
  const [error, setError] = useState('');

  // Fetch reviews on mount
  useEffect(() => {
    const fetchReviews = async () => {

      let url = "";
      setError('');

      if(userId) {
        url = `${API_BASE_URL}/reviews/user/${userId}`;
      } else if(bookId) {
        url = `${API_BASE_URL}/reviews/book/${bookId}`;
      } else {
        setError('No user or book id provided.');
        return;
      }
      
      try {
        const response = await axios.get(url, {
          headers: {Authorization: `Bearer ${token}`},
        });

        setReviews(response.data);
      }
      catch (error) {
        setError('Failed to fetch reviews');
      }
    }

    fetchReviews();

  }, [bookId, userId, token]);


  return (
    <div className="reviews-view">
    {error ? (
      <p className="error-message">{error}</p>
    ) : (
      reviews.length > 0 ? (
        reviews.map((review, index) => (
          <div key={index} className="review-card">
            <div className="review-header">
              {userId && <h4 className="review-username">{review.Book?.title}</h4>}
              {bookId && <h4 className="review-username">{review.User?.username || "Anonymous"}</h4>}
              <div className="review-rating">
                <StarRating rating={review.rating} />
              </div>
            </div>
            <p className="review-text">{review.review_text}</p>
            <div className="review-details-section">
              {review.pace_review && (
                <p>
                  Pace: <span className="review-details-selection">{review.pace_review}</span>
                </p>
              )}
              {review.plot_character_driven && (
                <p>
                  Plot/Character Driven: <span className="review-details-selection">{review.plot_character_driven}</span>
                </p>
              )}
            </div>
            {review.development_review && <p>Development: {review.development_review}</p>}
            {review.date_created && (
              <p className="review-date">
                Reviewed on {new Date(review.date_created).toLocaleDateString()} &nbsp;
                {review.date_created !== review.date_updated && (
                  <span className="review-date-edited">
                    Edited on {new Date(review.date_updated).toLocaleDateString()}
                  </span>
                )}
              </p>
            )}
            {index < reviews.length - 1 && <hr className="divider review-divider" />}
          </div>
        ))
      ) : (
        <p className="review-card">No reviews found.</p>
      )
    )}

  </div>
  );
};

export default ReviewsView;
